import { NetworkRepEntry } from "../../../network/@types/Url";
import { MalwareConfigAnnotation } from "../../@types/rldynamicanalysis";
import { MALWARE_CONFIG_ANNOTATION } from "./consts";

type Annotated = { annotations?: MalwareConfigAnnotation[] };

type WithSources = { extra?: Annotated[] };

const readRawAnnotations = (item?: object | null): MalwareConfigAnnotation[] =>
  ((item ?? {}) as Annotated).annotations ?? [];

const toAnnotationValue = (annotation: MalwareConfigAnnotation) =>
  typeof annotation === "string" ? annotation : annotation.value;

const readAnnotations = (item?: object | null): string[] =>
  readRawAnnotations(item).map(toAnnotationValue);

export const hasAnnotation = (item: object | undefined, annotation: string) =>
  readAnnotations(item).includes(annotation);

export const isMalwareConfigC2 = (item: object | undefined) =>
  hasAnnotation(item, MALWARE_CONFIG_ANNOTATION.C2);

export const isMalwareConfigPath = (item: object | undefined) =>
  hasAnnotation(item, MALWARE_CONFIG_ANNOTATION.PATH);

export const isMalwareConfigMutex = (item: object | undefined) =>
  hasAnnotation(item, MALWARE_CONFIG_ANNOTATION.MUTEX);

export const isNetworkIndicator = (item: NetworkRepEntry | undefined) =>
  item?.type === "ip" || item?.type === "url" || item?.type === "domain";

export const hasAssociatedMalware = (item: NetworkRepEntry | undefined) =>
  Boolean(item?.associated_malware);

export const isNetworkReferenceC2 = (item: object | undefined) =>
  Boolean(((item ?? {}) as WithSources).extra?.some(isMalwareConfigC2));

export const isRowMalwareConfigC2 = (item: object | undefined) =>
  isMalwareConfigC2(item) || isNetworkReferenceC2(item);

export const withMalwareConfigAnnotation = <T extends object>(
  item: T,
  annotation: string,
  matched: boolean
): T =>
  matched && !hasAnnotation(item, annotation)
    ? ({ ...item, annotations: [...readRawAnnotations(item), annotation] } as T)
    : item;
